var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ isBusy: _vm.busy },on:{"click":_vm.toggle}},[(!_vm.followState)?_c('v-icon',[_vm._v(" mdi-eye-off-outline ")]):_c('v-icon',[_vm._v(" mdi-eye-check ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }